import { render, staticRenderFns } from "./MsbcOrdersList.vue?vue&type=template&id=72bd27e2&"
import script from "./MsbcOrdersList.vue?vue&type=script&lang=js&"
export * from "./MsbcOrdersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports